// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"178":"5d1f937c","893":"0fdd2171"}[chunkId] + ".chunk.css";
};